/* Product main gallery: exactly 5 thumbnails visible, auto-sliding, dots.
   Desktop (>=992px): the 5 thumbs are a vertical column beside the main image; the track slides on Y.
   Mobile  (<992px):  the 5 thumbs are ONE horizontal row under the main image; the track slides on X
                      so images 6,7,8 come in one at a time. The section is not zoomed - it has a real
                      mobile layout (see mstrel-pdp-fix.css). */
(function(){
  var VIS=5, PITCH_Y=20.5846, GAP_X=8;
  function isDesktop(){ return (window.innerWidth||document.documentElement.clientWidth) >= 992; }

  function init(){
    var root=document.querySelector('.mstrel-pdp'); if(!root) return;
    root.style.zoom='';
    if(root.__mstrelGallery) return;
    var thumbsBox=root.querySelector('.mstrel-pdp__thumbs'), main=root.querySelector('.mstrel-pdp__main-img');
    if(!thumbsBox) return; root.__mstrelGallery=1;
    var track=thumbsBox.querySelector('.mstrel-pdp__thumbtrack');
    if(!track){ track=document.createElement('div'); track.className='mstrel-pdp__thumbtrack';
      while(thumbsBox.firstChild) track.appendChild(thumbsBox.firstChild);
      thumbsBox.appendChild(track); }
    var thumbs=[].slice.call(track.querySelectorAll('.mstrel-pdp__thumb'));
    if(!thumbs.length) return;
    var gallery=root.querySelector('.mstrel-pdp__gallery');
    var dotsBox=root.querySelector('.mstrel-pdp__dots');
    if(!dotsBox){ dotsBox=document.createElement('div'); dotsBox.className='mstrel-pdp__dots';
      var n=Math.min(VIS,thumbs.length);
      for(var i=0;i<n;i++){var d=document.createElement('span'); d.className='mstrel-pdp__dot'+(i?'':' is-active'); dotsBox.appendChild(d);}
      var sn=gallery.querySelector('.mstrel-pdp__sizenote');
      if(sn) gallery.insertBefore(dotsBox,sn); else gallery.appendChild(dotsBox); }
    var dots=[].slice.call(dotsBox.querySelectorAll('.mstrel-pdp__dot'));
    var cur=-1, timer=null;

    /* index of the first visible thumb so the active one is always in the window of 5 */
    function firstVisible(){
      if(thumbs.length<=VIS) return 0;
      return Math.min(Math.max(0, cur-2), thumbs.length-VIS);
    }
    function place(){
      var first=firstVisible();
      if(isDesktop()){
        track.style.transform='translateY(-'+(first*PITCH_Y)+'%)';
      } else {
        var w=thumbs[0]?thumbs[0].getBoundingClientRect().width:0;
        track.style.transform= first ? 'translateX(-'+(first*(w+GAP_X))+'px)' : 'translateX(0)';
      }
    }
    function show(i){
      cur=(i+thumbs.length)%thumbs.length;
      thumbs.forEach(function(x,n){x.classList.toggle('is-active',n===cur)});
      if(main){var f=thumbs[cur].getAttribute('data-full'); if(f){main.removeAttribute('srcset'); main.src=f;}}
      dots.forEach(function(d,n){d.classList.toggle('is-active',n===cur%dots.length)});
      place();
    }
    function play(){ stop(); if(thumbs.length>1) timer=setInterval(function(){show(cur+1)},4000); }
    function stop(){ if(timer){clearInterval(timer);timer=null;} }
    thumbs.forEach(function(t,n){ t.addEventListener('click',function(e){e.preventDefault();show(n);play();}); });
    if(gallery){ gallery.addEventListener('mouseenter',stop); gallery.addEventListener('mouseleave',play); }
    var rt; window.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(place,120)});
    window.addEventListener('load',place);
    show(0); play();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
